import { Body1, Body1Strong, Button, Caption1, Caption1Strong, Image, Spinner, Subtitle1, Title1, makeStyles, 
  mergeClasses, shorthands } from '@fluentui/react-components';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  ArrowLeftFilled,
  Payment32Regular
  } from "@fluentui/react-icons";
import { useLocation, useHistory } from 'react-router-dom';
import { useMsal, useAccount } from '@azure/msal-react';
import { silentRequest } from '../../authConfig';
import axios from 'axios';
import qrCode from 'qrcode';

const homeStyles = {
    border: 0,
    margin: 0,
    width: '100%',
    minWidth: 'calc(100vw - 310px)',
    background: '#FAF9F8',
    position: 'relative',
  };

  const useStyles = makeStyles({
    root: {
        display: "flex",
        // backgroundColor: "#fff",
        flexDirection: "column",
        width: "850px",
    },
    detail: {
        // ...shorthands.border("2px", "solid", "#ccc"),
        // ...shorthands.overflow("hidden"),
        display: "flex",
        // height: "480px",
        backgroundColor: "#fff",
        ...shorthands.gap("20px"),
        justifyContent: "center",
        ...shorthands.padding("20px"),
        // ...shorthands.border("2px", "solid", "#ccc"),
        boxShadow: "rgba(0, 0, 0, 0.133) 0px 1.6px 3.6px 0px, rgba(0, 0, 0, 0.11) 0px 0.3px 0.9px 0px",
        ...shorthands.borderRadius("10px"),
    },
    userDetail: {
        ...shorthands.border("2px", "solid", "#ccc"),
        ...shorthands.overflow("hidden"),
        display: "flex",
        height: "400px",
        width: "505px",
        ...shorthands.padding("10px", "20px"),
        ...shorthands.borderRadius("10px"),
    },
    paymentDetail: {
        ...shorthands.border("2px", "solid", "#ccc"),
        ...shorthands.overflow("hidden"),
        display: "flex",
        height: "400px",
        width: "319px",
        ...shorthands.padding("10px", "20px"),
        ...shorthands.borderRadius("10px")
    },
    flex: {
      display: "flex", 
      justifyContent: "end", 
      alignItems: "center",
      ...shorthands.gap("20px"),
    },
    flexLeft: {
      display: "flex", 
      justifyContent: "start", 
      alignItems: "center",
      ...shorthands.gap("5px"),
    },
    contentSpacing: {
      display: "flex", 
      alignItems: "center",
      ...shorthands.gap("5px"),
    },
    stack: {
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'nowrap',
      width: 'auto',
      height: 'auto',
      boxSizing: 'border-box',
      '> *': {
        textOverflow: 'ellipsis',
      },
      '> :not(:first-child)': {
        marginTop: '0px',
      },
      '> *:not(.ms-StackItem)': {
        flexShrink: 1,
      },
    },
    vertical: {
      display: 'flex',
      flexDirection: 'column',
    },
    verticalCenter: {
      display: 'flex',
      alignItems: "center"
    },
    fullWidth: {
      width: "100%"
    },
    spaceBetween: {
      justifyContent: "space-between"
    },
    columnGap: {
      ...shorthands.gap("0px", "10px"),
    },
    rowGap: {
      ...shorthands.gap("10px", "0px"),
    },
    horizontalCenter: {
      display: "flex",
      justifyContent: "center"
    },
    flexWrap: {
      display: "flex",
      flexWrap: "wrap"
    },
    width50Percent: {
      width: "40%",
      ...shorthands.margin("10px", "20px"),
      ...shorthands.borderBottom("2px", "solid", "black"),
    },
  });

//   const slideDown = keyframes`
//   from {
//     transform: translateY(-100%);
//   }
//   to {
//     transform: translateY(0);
//   }
// `;

// const AnimatedRow = styled.tr`
//   border: 1px solid black;
//   padding: 8px;
//   animation: ${slideDown} 0.5s ease;
// `;

function makeDecimalNumber(num) {
  return num.toLocaleString(undefined, {
     maximumFractionDigits: 2,
     minimumFractionDigits: 2,
   })
 }

const API_URL = process.env.REACT_APP_API_URL;
// const UAT_API_URL = 'https://ws.uat-lcpt.com'

const PaymentViewQR = () => {
    const styles = useStyles();

    const { t } = useTranslation();

    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0] || {});

    const location = useLocation();
    const history = useHistory();

    const [companyData, setCompanyData] = useState(null);

    const companyId = sessionStorage.getItem('companyId') || '';

    const [qrCodeSrc, setQrCodeSrc] = useState(null)

    const [manual, setManual] = useState(true)
    const [loading, setLoading] = useState(true)
    
    const [paymentToken, setPaymentToken] = useState("")

    const [total, setTotal] = useState(0)

    const [time, setTime] = useState({ minutes: 15, seconds: 0 });

    const [fileId, setFileId] = useState("")

    const [getCompanyDetailSuccess, setGetCompanyDetailSuccess] = useState(false)
    const [getQrCodeSuccess, setGetQrCodeSuccess] = useState(false)
        
    useEffect(() => {
      if (getCompanyDetailSuccess && getQrCodeSuccess) {
        setLoading(false)
      }
    }, [getCompanyDetailSuccess, getQrCodeSuccess])

    async function fetchCompanyData() {
      console.log('userEffect retrieve company and accounts data!');
  
      const urlPath = window.location.pathname;
      console.log('Body urlPath: ', urlPath);
  
      await instance
        .acquireTokenSilent({ ...silentRequest, account: account })
        .then((tokenResponse) => {
          console.log('tokenResponse: ', tokenResponse);
  
          axios
            .get(API_URL + '/etax/companies', {
              headers: {
                Authorization: 'Bearer ' + tokenResponse.accessToken,
              },
            })
            .then(
              (response) => {
                console.log(response);
  
                if (response.data.length === 0) {
                } else {
  
                  let _cid = ""
                  if (sessionStorage.getItem("companyId") && response.data.find(_company => _company.id === sessionStorage.getItem("companyId"))) {
                    setCompanyData(response.data.find(_company => _company.id === sessionStorage.getItem("companyId")));

                    console.log(response.data.find(_company => _company.id === sessionStorage.getItem("companyId")))
                    // sessionStorage.setItem("companyId", response.data[0].id);
                    _cid = sessionStorage.getItem("companyId")
                  } else {
                    setCompanyData(response.data[0]);
                    sessionStorage.setItem("companyId", response.data[0].id);
  
                    _cid = response.data[0].id
                  }
  
                  axios
                      .get(API_URL + '/companies-details', {
                          headers: {
                              Authorization: 'Bearer ' + tokenResponse.accessToken,
                              'cid': _cid
                          },
                      })
                      .then((companiesDetailsResponse) => {
                          console.log('companiesDetailsResponse: ', companiesDetailsResponse);
                          if (companiesDetailsResponse.data) {
                            if (companiesDetailsResponse.data.billings === undefined || companiesDetailsResponse.data.billings.manual === undefined || companiesDetailsResponse.data.billings.manual) {
                              setManual(true)
                              setLoading(false)

                              // history.push({
                              //   pathname: '/etax/documents/all',
                              //   state: {},
                              // });
                            } else {
                              setManual(false)
                            }

                            setGetCompanyDetailSuccess(true)
                          }
  
                      })
                      .catch((error) => {
                          console.log(error);
                      })
                   }
              },
              (error) => {
                console.log(error);
              }
            );
        })
        .catch((error) => {
          //Acquire token silent failure, and send an interactive request
          console.log(error);
          instance.acquireTokenRedirect(silentRequest);
        });
  
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }

    async function initLocationProps(_location) {
      const locationProps = _location.state

      console.log("locationProps", locationProps)
      if (locationProps) {
        const _fileId = locationProps.fileId

        setFileId(_fileId)

        handlePaymentPromptPay(_fileId)
      }
      
    }

    useEffect(() => {
      fetchCompanyData()
      initLocationProps(location)

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function handlePaymentPromptPay(_fileId) {
      setLoading(true)

      // console.log("_statementList", _statementList)
      // const _statements = _statementList.join(",")

      instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then(async (tokenResponse) => {
        const response = await axios.post(`${API_URL}/payments/2c2p/prompt-pay/qr`,
                                {
                                  fileId: _fileId
                                },
                                {
                                  headers: {
                                    Authorization: 'Bearer ' + tokenResponse.accessToken,
                                    cid: companyId,
                                  },
                                })

        console.log("response handlePayment", response)

        // setLoading(false)
        if (response.data.data) {
          qrCode
            .toDataURL(response.data.data)
            .then((url) => {
              setQrCodeSrc(url);

              setTotal(response.data.total)

              setGetQrCodeSuccess(true)
            })
            .catch((err) => {
              console.error(err);
            });

          setPaymentToken(response.data.paymentToken)
          setStartLoopingForTransactionStatus(true)
        }
      }).catch((error) => {
        //Acquire token silent failure, and send an interactive request
        console.log("handlePaymentPromptPay", error);
        // instance.acquireTokenRedirect(silentRequest);
        history.push({
          pathname: '/payments/channels',
          state: {...location.state, error: true},
        });

      });
    }

    const [startLoopingForTransactionStatus, setStartLoopingForTransactionStatus] = useState(false)
    
    const intervalRef = useRef(null);

    function getTransactionStatus(_paymetToken) {
      instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then(async (tokenResponse) => {
        const response = await axios.get(`${API_URL}/payments/2c2p/prompt-pay/transaction-status`, {
                            headers: {
                              Authorization: 'Bearer ' + tokenResponse.accessToken,
                              cid: companyId,
                            },
                            params: {
                              paymentToken: _paymetToken
                            }
                          })

        console.log("response getTransactionStatus", response)
        console.log("response Time", new Date().toISOString())

        if (response.data.respCode === "2000") { 
          setStartLoopingForTransactionStatus(false)

          history.push({
            pathname: '/payments/result',
            state: {
              status: "complete",
              fileId: fileId,
              invoiceNo: response.data.invoiceNo,
              transactionDetails: response.data.additionalInfo.transactionDetails
            },
          });
        } else { // ต้อง loop ต่อ
          // setStartLoopingForTransactionStatus(false)

          // history.push({
          //   pathname: '/payment-result',
          //   state: {
          //     status: "complete",
          //     invoiceNo: response.data.invoiceNo,
          //     transactionDetails: response.data.additionalInfo.transactionDetails
          //   },
          // });
        }

      }).catch((error) => {
        //Acquire token silent failure, and send an interactive request
        console.log(error);

        setStartLoopingForTransactionStatus(false)

        history.push({
          pathname: '/payments/result',
          state: {
            status: "fail",
            invoiceNo: "",
            transactionDetails: null
          },
        });
      })
    }

    useEffect(() => {
      console.log("startLoopingForTransactionStatus", startLoopingForTransactionStatus)
      console.log("paymentToken", paymentToken)

      if (startLoopingForTransactionStatus && paymentToken) {
        getTransactionStatus(paymentToken) // Fetch data initially
        startTimer()

        const startTime = Date.now();
        const intervalId = setInterval(() => {
          const elapsedTime = Date.now() - startTime;
          if (elapsedTime >= 900000) {
            clearInterval(intervalId);

            history.push({
              pathname: '/payments/result',
              state: {
                status: "fail",
                invoiceNo: "",
                transactionDetails: null
              },
            });
          } else {
            getTransactionStatus(paymentToken) // Fetch data every 5 seconds
          }
        }, 5000);

        return () => {
          clearInterval(intervalId);
        };
      }

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startLoopingForTransactionStatus, paymentToken])

    const startTimer = () => {
      if (intervalRef.current) return; // Prevent multiple intervals
  
      intervalRef.current = setInterval(() => {
        setTime((prevTime) => {
          const { minutes, seconds } = prevTime;
          if (seconds > 0) {
            return { minutes, seconds: seconds - 1 };
          }
          if (minutes > 0) {
            return { minutes: minutes - 1, seconds: 59 };
          }
          clearInterval(intervalRef.current);
          return { minutes: 0, seconds: 0 };
        });
      }, 1000);
    };

    useEffect(() => {
      if (time.minutes <= 0 && time.seconds <= 0) {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
      }
    }, [time])
    
   
    const downloadImage = async (_imageSrc) => {
      const response = await fetch(_imageSrc);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
  
      const link = document.createElement('a');
      link.href = url;
      link.download = `qrcode-statement-${new Date().toISOString()}.png`
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    };

    function handleGoback(e) {
      setQrCodeSrc(null)

      history.push({
        pathname: '/payments/channels',
        state: location.state,
      });
    }

    return <div style={homeStyles}>
      {manual ? (
        <div style={{ display: "flex", justifyContent: "center", marginTop: 21}}>
          {loading ? (
            <div style={{ display: "flex", alignContent: "center", height: "100%", width: "100%", justifyContent: "center"}}>
              <Spinner labelPosition="below" label={t(`paymentViewQR.loading`)} />
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column"}}>
              <div style={{ marginBottom: 21}}>
                <Subtitle1>{t(`paymentViewQR.thisPageCannotReach`)}</Subtitle1>
  
              </div>
              <div style={{ display: "flex", justifyContent: "center"}}>
                <Button 
                  appearance='primary' 
                  onClick={() =>  
                    history.push({
                      pathname: '/etax/documents/all',
                      state: {},
                    })}
                >
                  {t(`paymentViewQR.homepage`)}
                </Button>
                
              </div>
            </div>
          )}
        </div>
      ) : (
        <div style={{ display: "flex", justifyContent: "center"}}>
            <div className={styles.root}>
                <Title1 as='h1'>
                  <div style={{ display: "flex", flexDirection: "row"}}>
                    <div className={styles.verticalCenter} style={{ paddingRight: 5}}>
                      <Payment32Regular />
                    </div>
                    <div className={styles.verticalCenter}>
                      <div>
                        {t(`paymentViewQR.paymentViewQRHeader`)}

                      </div>
                    </div>
                  </div>
                </Title1>
                <div className={styles.detail}>
                  <div className={mergeClasses(styles.vertical, styles.fullWidth, styles.columnGap)}>
                    <div onClick={handleGoback} style={{ display: "flex", flexDirection: "row"}}>
                      <div className={styles.verticalCenter} style={{ paddingRight: 5}}>
                        <ArrowLeftFilled />
                      </div>
                      <div className={styles.verticalCenter}>
                        <Body1>{t(`paymentViewQR.back`)}</Body1>
                      </div>
                    </div>
                    {loading ? (
                        <div style={{ display: "flex", alignContent: "center", height: "100%", width: "100%", justifyContent: "center"}}>
                          <Spinner labelPosition="below" label={t(`paymentViewQR.loading`)} />

                        </div>
                    ) : (
                      <>
                        <div className={mergeClasses(styles.vertical, styles.columnGap)}>
                          <span><Body1Strong>{t(`paymentViewQR.name`)}: </Body1Strong> <Body1>{companyData?.name || ""}</Body1></span>
                          <span><Body1Strong>{t(`paymentViewQR.tel`)}: </Body1Strong> <Body1>{companyData?.phone || ""}</Body1></span>
                          <span><Body1Strong>{t(`paymentViewQR.billingAddress`)}: </Body1Strong> <Body1>{companyData ? companyData.buildingNumber +
                                          ' ' +
                                          (!/^-*$/.test(companyData.address) && companyData.address.trim() && !/^-*$/.test(companyData.address.trim()) ? companyData.address + ' ' : '') +
                                          (!/^-*$/.test(companyData.streetName) && companyData.streetName.trim() && !/^-*$/.test(companyData.streetName.trim())
                                            ? companyData.streetPrefix + companyData.streetName + ' '
                                            : '') +
                                          companyData.subDistrictPrefix +
                                          companyData.subDistrictName +
                                          ' ' +
                                          companyData.districtPrefix +
                                          companyData.districtName +
                                          ' ' +
                                          companyData.provincePrefix +
                                          companyData.provinceName +
                                          ' ' +
                                          companyData.postcode : ""}</Body1>
                          </span>
                        </div>
                        <div className={styles.horizontalCenter}>
                          <Body1Strong>{t(`paymentViewQR.amountDue`)}</Body1Strong>
                        </div>
                        <div className={mergeClasses(styles.fullWidth, styles.rowGap)} style={{ border: "1px solid #0f6cbd", borderRadius: 10, height: 30, display: "flex", flexDirection: "row", padding: "10px 0px 10px 0px", alignItems: "center", justifyContent: "center"}}>
                          <Title1 style={{ color: "#0f6cbd"}}>{makeDecimalNumber(total)}</Title1>
                          <label>
                            {t(`paymentViewQR.baht`)}
                          </label>
                        </div>
                        {/* <div className={styles.horizontalCenter}>
                          <Caption1>QR Code นี้สำหรับชำระภายในวันที่ 11/03/2024 23:59:59</Caption1>
                        </div>
                        <br /> */}
                        <div className={styles.horizontalCenter}>
                          <Caption1>{t(`paymentViewQR.pleasePayWithin`)} {time.minutes}:{time.seconds < 10 ? `0${time.seconds}` : time.seconds}</Caption1>
                        </div>
                        <br />
                        <div className={styles.horizontalCenter} >
                          <div style={{ width: 500, height: 54, backgroundColor: "#0e3d67", display: "flex", justifyContent: "center"}}>
                            <Image height={54} src='/images/thai-qr-payment.png' />
                          </div>
                        </div>
                        {/* <div className={styles.horizontalCenter}>
                          <Caption1>
                            PromptPay
                          </Caption1>
                        </div> */}
                        <div className={styles.horizontalCenter}>
                          <Image height={44} src='/images/promtpay-logo.png' />
                        </div>
                        <div className={styles.horizontalCenter}>
                          {/* <Link as='a' href={link} >
                            ทดสอบเข้าลิ้งค์
                          </Link> */}
                          <Image 
                            src={qrCodeSrc}
                            height={200}
                            width={200} 
                          />
                        </div>
                        <div className={styles.horizontalCenter}>
                          <Button onClick={() => downloadImage(qrCodeSrc)}>
                            {t(`paymentViewQR.saveQrCode`)}
                          </Button>
                        </div>
                        <>
                          <Caption1Strong>
                            {t(`paymentViewQR.pleaseFollow`)}
                          </Caption1Strong>
                          <Caption1>
                            {t(`paymentViewQR.pleaseFollow1`)}
                          </Caption1>
                          <Caption1>
                            {t(`paymentViewQR.pleaseFollow2`)}
                          </Caption1>
                          <Caption1>
                            {t(`paymentViewQR.pleaseFollow3`)}
                          </Caption1>
                          <Caption1>
                            {t(`paymentViewQR.pleaseFollow4`)}
                          </Caption1>
                          <Caption1>
                            {t(`paymentViewQR.pleaseFollow5`)}
                          </Caption1>
                          <Caption1>
                            {t(`paymentViewQR.pleaseFollow6`)}
                          </Caption1>
                        </>
                      </>
                    )}
                  </div>
                </div>
            </div>

        </div>
      )}
    </div>
};

export default PaymentViewQR;